<ng-container *ngIf="invitee$ | async as invitee">
  <div class="list-item-header">
    <div class="employee-name-container">
      <div
        class="employee-name"
        data-cy="job-request-invitee-name">
        <div
          class="employee-name__name"
          [attr.title]="
            (customer$ | async)?.prioritizeEmployeeLastName
              ? invitee.personalData?.lastName +
                ' ' +
                invitee.personalData?.firstName
              : invitee.personalData?.firstName +
                ' ' +
                invitee.personalData?.lastName
          "
          [class.is-canceled]="invitee.status === inviteeStatusEnum.CANCELED">
          {{
            (customer$ | async)?.prioritizeEmployeeLastName
              ? invitee.personalData?.lastName
              : invitee.personalData?.firstName
          }}
          {{
            (customer$ | async)?.prioritizeEmployeeLastName
              ? invitee.personalData?.firstName
              : invitee.personalData?.lastName
          }}
        </div>
        <div
          class="employee-name__canceled-text"
          *ngIf="invitee.status === inviteeStatusEnum.CANCELED">
          ({{ "canceled" | i18n | titlecase }})
        </div>
      </div>
      <div
        class="employee-customer"
        *ngIf="invitee.customer?.id !== (customer$ | async)?._id"
        [attr.data-cy]="'origin-customer-id-' + invitee.customer?.id">
        via
        {{ invitee.customer?.displayName }}
      </div>
    </div>

    <div
      *ngIf="extraInviteeCount$ | async as extraInviteeCount"
      class="extra-invitees-count"
      data-cy="extra-invitees-count">
      <div class="extra-invitees-count-tag">+{{ extraInviteeCount }}</div>
    </div>
  </div>
</ng-container>
